import { render, staticRenderFns } from "./SfProductCardSkeleton.vue?vue&type=template&id=10e11ec0&scoped=true&"
import script from "./SfProductCardSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SfProductCardSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./SfProductCardSkeleton.vue?vue&type=style&index=0&id=10e11ec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e11ec0",
  null
  
)

export default component.exports